import { useState, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const BASE = 4289;
const RANGE = 300;

export function DynamicLearningTicker() {
  const { t } = useLanguage();
  const [count, setCount] = useState(() => BASE + Math.floor(Math.random() * RANGE));

  useEffect(() => {
    const interval = setInterval(() => {
      const delta = Math.random() > 0.4 ? Math.floor(Math.random() * 5) + 1 : -(Math.floor(Math.random() * 3) + 1);
      setCount((prev) => Math.max(BASE, Math.min(BASE + RANGE, prev + delta)));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const formatted = count.toLocaleString("en-IN");
  const label = t("academy.learningTickerTemplate").replace("{count}", formatted);

  return (
    <span className="inline-flex items-center gap-2 text-xs text-muted-foreground">
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
      </span>
      <span className="indic-text">{label}</span>
    </span>
  );
}
